import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { FormBuilder, FormControl, FormGroup, Validators, } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { UmsService } from '../ums.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';

@Component({
  selector: 'app-course-level-qualification',
  templateUrl: './course-level-qualification.component.html',
  styleUrls: ['./course-level-qualification.component.scss']
})
export class CourseLevelQualificationComponent implements OnInit {
  
  CourseLevelQualificationForm: FormGroup;
  filteredCourseList: any;
  courseList: any;
  courseLevelList: any;
  filteredCourseLevelList: any;
  courseRecords: any[] = [];
  Table: boolean = false;
  dialogRef: MatDialogRef<any>;
  highestQualCourseLevel: any;
  courseQualificationConfig: any[] = [];
  Course: any;

  constructor(
      public umsService: UmsService,
      private modalPopupService: ModalpopService,
      private fb: FormBuilder,
      public router: Router,
      private route: ActivatedRoute,
      private spinner: NgxSpinnerService,
      private httpClient: HttpClient,
    ) { }

  ngOnInit(): void {
      this.CourseLevelQualificationForm = this.fb.group({
        CoCode: ['', Validators.required],
        CdDesc: ['', Validators.required]
    });
      this.getCourseData();
      this.CourseLevelData();
      this.showFields()
}

  getCourseData() {
      this.spinner.show();
      const payload = {};
      this.umsService.getCourse(payload).subscribe(res => {
        this.spinner.hide();
        this.courseList = res.data;
        this.filteredCourseList = this.courseList.slice();
      },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        
      });
    }

  onCourseChange() {
  // Add your course change logic here
  }

  CourseLevelData() {
      this.spinner.show();
      const payload = {};
      payload['CdType'] = "COLVL"
      this.umsService.getCodeType(payload).subscribe(res => {
        this.spinner.hide();
        this.courseLevelList = res.data;
        this.filteredCourseLevelList = this.courseLevelList.slice();
      },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        
      });
  }

  getSavedCourseQualificationConfig(courseCode: string) {
    if (!courseCode) {
    return;
  }
    const payload = {
    CoQcCoCode: courseCode
  };
    this.spinner.show();
    this.umsService.searchCourseQualification(payload).subscribe(
      (res) => {
      this.spinner.hide();
      if (res.status && res.data) {
        console.log('Saved Course Qualification Config:', res.data);
        if (res.data.Fields) {
          this.courseRecords = this.courseRecords.map((item) => {
            const savedField = res.data.Fields[item.FormControlName];
            if (savedField) {
              item.FormVisible = savedField.show;
            }
            return item;
          });
        }
        this.Table = true;
      }
    },
    (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    }
  );
}

showFields() {
  this.spinner.show();
  const payload = {
    FormPage: 'QualifyDetails'
  };
  this.umsService.getStdSetting(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status && res.data && res.data.length > 0) {
          this.courseRecords = res.data;
          this.Table = true;
        } else {
          this.courseRecords = [];
          this.Table = false;
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.courseRecords = [];
        this.Table = false;
      }
    );
}

saveFields() {

  const CoQcCoCode = this.CourseLevelQualificationForm.get('CoCode')?.value;
  const CoQcCoLvl = this.CourseLevelQualificationForm.get('CdDesc')?.value;
  
  if (this.CourseLevelQualificationForm.invalid) {
    this.CourseLevelQualificationForm.markAllAsTouched();
    return;
  }
  const Fields = {};
  this.courseRecords.forEach((item) => {
    Fields[item.FormControlName] = {
      show: item.FormVisible,
      // validate: ['required']
      validate: item.FormRequired ? ['required'] : []
    };
  });
  const payload = {
    CoQcCoCode: CoQcCoCode,
    CoQcCoLvl: CoQcCoLvl,
    FormPage: 'QualifyDetails',
    Fields: Fields
  };
  console.log('Course Qualification Config Payload:',payload);
  this.spinner.show();
  this.umsService.saveCourseQualiConfig(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef =
            this.modalPopupService.openPopup<AlertBoxComponent>(
              AlertBoxComponent,
              data
            );
          this.getSavedCourseQualificationConfig(CoQcCoCode);
        } else {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef =
            this.modalPopupService.openPopup<AlertBoxComponent>(
              AlertBoxComponent,
              data
            );
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
      }
    );
}

}
